"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * PlumbingWorld-3.0
 * PlumbingWorld API
 *
 * Contact: jspencer@juliusspencer.co.nz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var ContentApi = /** @class */ (function (_super) {
    __extends(ContentApi, _super);
    function ContentApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Add a carousel item
     */
    ContentApi.prototype.createCarouselItemRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.platform === null || requestParameters.platform === undefined) {
                            throw new runtime.RequiredError('platform', 'Required parameter requestParameters.platform was null or undefined when calling createCarouselItem.');
                        }
                        queryParameters = {};
                        if (requestParameters.platform !== undefined) {
                            queryParameters['platform'] = requestParameters.platform;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["admin"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin/content/carousel/add",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.AddCarouselItemRequestToJSON(requestParameters.addCarouselItemRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.CarouselResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Add a carousel item
     */
    ContentApi.prototype.createCarouselItem = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createCarouselItemRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Add a home page item
     */
    ContentApi.prototype.createHomePageItemRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.platform === null || requestParameters.platform === undefined) {
                            throw new runtime.RequiredError('platform', 'Required parameter requestParameters.platform was null or undefined when calling createHomePageItem.');
                        }
                        queryParameters = {};
                        if (requestParameters.platform !== undefined) {
                            queryParameters['platform'] = requestParameters.platform;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["admin"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin/content/homePage/add",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.AddHomePageItemRequestToJSON(requestParameters.addHomePageItemRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.HomePageItemsResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Add a home page item
     */
    ContentApi.prototype.createHomePageItem = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createHomePageItemRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete carousel item
     */
    ContentApi.prototype.deleteCarouselItemRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling deleteCarouselItem.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["admin"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin/content/carousel/{id}".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.CarouselResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Delete carousel item
     */
    ContentApi.prototype.deleteCarouselItem = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteCarouselItemRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete home page item
     */
    ContentApi.prototype.deleteHomePageItemRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling deleteHomePageItem.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["admin"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin/content/homePage/{id}".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.HomePageItemsResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Delete home page item
     */
    ContentApi.prototype.deleteHomePageItem = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteHomePageItemRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Downloads a cheat sheet of labels from a label group
     */
    ContentApi.prototype.downloadLabelsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.labelGroupId === null || requestParameters.labelGroupId === undefined) {
                            throw new runtime.RequiredError('labelGroupId', 'Required parameter requestParameters.labelGroupId was null or undefined when calling downloadLabels.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/labels/{labelGroupId}/download".replace("{" + "labelGroupId" + "}", encodeURIComponent(String(requestParameters.labelGroupId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.BlobApiResponse(response)];
                }
            });
        });
    };
    /**
     * Downloads a cheat sheet of labels from a label group
     */
    ContentApi.prototype.downloadLabels = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.downloadLabelsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get all product branches
     */
    ContentApi.prototype.getAllProductBranchesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.mobileOnly !== undefined) {
                            queryParameters['mobileOnly'] = requestParameters.mobileOnly;
                        }
                        headerParameters = {};
                        if (requestParameters.ifModifiedSince !== undefined && requestParameters.ifModifiedSince !== null) {
                            headerParameters['If-Modified-Since'] = String(requestParameters.ifModifiedSince);
                        }
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-API-Key"] = this.configuration.apiKey("X-API-Key"); // ApiKeyAuth authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/products/branch",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ProductBranchesResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get all product branches
     */
    ContentApi.prototype.getAllProductBranches = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAllProductBranchesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get all branches
     */
    ContentApi.prototype.getBranchesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.orderBranch !== undefined) {
                            queryParameters['orderBranch'] = requestParameters.orderBranch;
                        }
                        headerParameters = {};
                        if (requestParameters.ifModifiedSince !== undefined && requestParameters.ifModifiedSince !== null) {
                            headerParameters['If-Modified-Since'] = String(requestParameters.ifModifiedSince);
                        }
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-API-Key"] = this.configuration.apiKey("X-API-Key"); // ApiKeyAuth authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/branches",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.BranchesResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get all branches
     */
    ContentApi.prototype.getBranches = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBranchesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets the carousel content for the platform
     */
    ContentApi.prototype.getCarouselRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.platform === null || requestParameters.platform === undefined) {
                            throw new runtime.RequiredError('platform', 'Required parameter requestParameters.platform was null or undefined when calling getCarousel.');
                        }
                        queryParameters = {};
                        if (requestParameters.platform !== undefined) {
                            queryParameters['platform'] = requestParameters.platform;
                        }
                        if (requestParameters.active !== undefined) {
                            queryParameters['active'] = requestParameters.active;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-API-Key"] = this.configuration.apiKey("X-API-Key"); // ApiKeyAuth authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/content/carousel",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.CarouselResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets the carousel content for the platform
     */
    ContentApi.prototype.getCarousel = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCarouselRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get category without sub-categories
     */
    ContentApi.prototype.getCategoryRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getCategory.');
                        }
                        queryParameters = {};
                        if (requestParameters.customerId !== undefined) {
                            queryParameters['customerId'] = requestParameters.customerId;
                        }
                        if (requestParameters.includePrices !== undefined) {
                            queryParameters['includePrices'] = requestParameters.includePrices;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.pageSize !== undefined) {
                            queryParameters['pageSize'] = requestParameters.pageSize;
                        }
                        if (requestParameters.branchId !== undefined) {
                            queryParameters['branchId'] = requestParameters.branchId;
                        }
                        if (requestParameters.productRange !== undefined) {
                            queryParameters['productRange'] = requestParameters.productRange;
                        }
                        if (requestParameters.goldProductsOnly !== undefined) {
                            queryParameters['goldProductsOnly'] = requestParameters.goldProductsOnly;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/categories/{id}".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.CategoryResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get category without sub-categories
     */
    ContentApi.prototype.getCategory = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCategoryRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets the home page content for the platform
     */
    ContentApi.prototype.getHomePageContentRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.platform === null || requestParameters.platform === undefined) {
                            throw new runtime.RequiredError('platform', 'Required parameter requestParameters.platform was null or undefined when calling getHomePageContent.');
                        }
                        queryParameters = {};
                        if (requestParameters.platform !== undefined) {
                            queryParameters['platform'] = requestParameters.platform;
                        }
                        if (requestParameters.active !== undefined) {
                            queryParameters['active'] = requestParameters.active;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-API-Key"] = this.configuration.apiKey("X-API-Key"); // ApiKeyAuth authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/content/homePage",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.HomePageItemsResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets the home page content for the platform
     */
    ContentApi.prototype.getHomePageContent = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHomePageContentRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get product
     */
    ContentApi.prototype.getProductRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.sku === null || requestParameters.sku === undefined) {
                            throw new runtime.RequiredError('sku', 'Required parameter requestParameters.sku was null or undefined when calling getProduct.');
                        }
                        queryParameters = {};
                        if (requestParameters.sku !== undefined) {
                            queryParameters['sku'] = requestParameters.sku;
                        }
                        if (requestParameters.customerId !== undefined) {
                            queryParameters['customerId'] = requestParameters.customerId;
                        }
                        if (requestParameters.includePrices !== undefined) {
                            queryParameters['includePrices'] = requestParameters.includePrices;
                        }
                        if (requestParameters.includeStockInformation !== undefined) {
                            queryParameters['includeStockInformation'] = requestParameters.includeStockInformation;
                        }
                        if (requestParameters.branchId !== undefined) {
                            queryParameters['branchId'] = requestParameters.branchId;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/products/details",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ProductFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get product
     */
    ContentApi.prototype.getProduct = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getProductRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get product prices for a given array of product skus
     */
    ContentApi.prototype.getProductPricesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.productPriceRequestList === null || requestParameters.productPriceRequestList === undefined) {
                            throw new runtime.RequiredError('productPriceRequestList', 'Required parameter requestParameters.productPriceRequestList was null or undefined when calling getProductPrices.');
                        }
                        queryParameters = {};
                        if (requestParameters.customerId !== undefined) {
                            queryParameters['customerId'] = requestParameters.customerId;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/products/prices",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.ProductPriceRequestListToJSON(requestParameters.productPriceRequestList),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ProductPricesResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get product prices for a given array of product skus
     */
    ContentApi.prototype.getProductPrices = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getProductPricesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get stock count for a product at a branch
     */
    ContentApi.prototype.getProductStockRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.sku === null || requestParameters.sku === undefined) {
                            throw new runtime.RequiredError('sku', 'Required parameter requestParameters.sku was null or undefined when calling getProductStock.');
                        }
                        if (requestParameters.branchId === null || requestParameters.branchId === undefined) {
                            throw new runtime.RequiredError('branchId', 'Required parameter requestParameters.branchId was null or undefined when calling getProductStock.');
                        }
                        queryParameters = {};
                        if (requestParameters.sku !== undefined) {
                            queryParameters['sku'] = requestParameters.sku;
                        }
                        if (requestParameters.branchId !== undefined) {
                            queryParameters['branchId'] = requestParameters.branchId;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/products/stock",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.BranchProductDetailFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get stock count for a product at a branch
     */
    ContentApi.prototype.getProductStock = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getProductStockRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get stock count for a product at the given branches
     */
    ContentApi.prototype.getProductStocksRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.sku === null || requestParameters.sku === undefined) {
                            throw new runtime.RequiredError('sku', 'Required parameter requestParameters.sku was null or undefined when calling getProductStocks.');
                        }
                        queryParameters = {};
                        if (requestParameters.sku !== undefined) {
                            queryParameters['sku'] = requestParameters.sku;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/products/stocks",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.ProductStocksRequestToJSON(requestParameters.productStocksRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.BranchProductsResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get stock count for a product at the given branches
     */
    ContentApi.prototype.getProductStocks = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getProductStocksRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get all products and categories (not paged)
     */
    ContentApi.prototype.getProductsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.mobileOnly !== undefined) {
                            queryParameters['mobileOnly'] = requestParameters.mobileOnly;
                        }
                        headerParameters = {};
                        if (requestParameters.ifModifiedSince !== undefined && requestParameters.ifModifiedSince !== null) {
                            headerParameters['If-Modified-Since'] = String(requestParameters.ifModifiedSince);
                        }
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-API-Key"] = this.configuration.apiKey("X-API-Key"); // ApiKeyAuth authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/products",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ProductsResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get all products and categories (not paged)
     */
    ContentApi.prototype.getProducts = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getProductsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get filters for search query
     */
    ContentApi.prototype.getSearchFiltersRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.query !== undefined) {
                            queryParameters['query'] = requestParameters.query;
                        }
                        if (requestParameters.categoryId !== undefined) {
                            queryParameters['categoryId'] = requestParameters.categoryId;
                        }
                        if (requestParameters.customerId !== undefined) {
                            queryParameters['customerId'] = requestParameters.customerId;
                        }
                        if (requestParameters.includePrices !== undefined) {
                            queryParameters['includePrices'] = requestParameters.includePrices;
                        }
                        if (requestParameters.hnzProductsOnly !== undefined) {
                            queryParameters['hnzProductsOnly'] = requestParameters.hnzProductsOnly;
                        }
                        if (requestParameters.branchId !== undefined) {
                            queryParameters['branchId'] = requestParameters.branchId;
                        }
                        if (requestParameters.productRange !== undefined) {
                            queryParameters['productRange'] = requestParameters.productRange;
                        }
                        if (requestParameters.goldProductsOnly !== undefined) {
                            queryParameters['goldProductsOnly'] = requestParameters.goldProductsOnly;
                        }
                        if (requestParameters.includeAttributes !== undefined) {
                            queryParameters['includeAttributes'] = requestParameters.includeAttributes;
                        }
                        if (requestParameters.allProducts !== undefined) {
                            queryParameters['allProducts'] = requestParameters.allProducts;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/search/filters",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.SearchFiltersResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get filters for search query
     */
    ContentApi.prototype.getSearchFilters = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSearchFiltersRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get filters for a product search with filters applied (eg fetching HWC products require some filters to always be applied to ensure only hot water cylinders are returned)
     */
    ContentApi.prototype.getSearchFiltersWithFiltersAppliedRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.query !== undefined) {
                            queryParameters['query'] = requestParameters.query;
                        }
                        if (requestParameters.categoryId !== undefined) {
                            queryParameters['categoryId'] = requestParameters.categoryId;
                        }
                        if (requestParameters.customerId !== undefined) {
                            queryParameters['customerId'] = requestParameters.customerId;
                        }
                        if (requestParameters.includePrices !== undefined) {
                            queryParameters['includePrices'] = requestParameters.includePrices;
                        }
                        if (requestParameters.hnzProductsOnly !== undefined) {
                            queryParameters['hnzProductsOnly'] = requestParameters.hnzProductsOnly;
                        }
                        if (requestParameters.branchId !== undefined) {
                            queryParameters['branchId'] = requestParameters.branchId;
                        }
                        if (requestParameters.productRange !== undefined) {
                            queryParameters['productRange'] = requestParameters.productRange;
                        }
                        if (requestParameters.goldProductsOnly !== undefined) {
                            queryParameters['goldProductsOnly'] = requestParameters.goldProductsOnly;
                        }
                        if (requestParameters.includeAttributes !== undefined) {
                            queryParameters['includeAttributes'] = requestParameters.includeAttributes;
                        }
                        if (requestParameters.allProducts !== undefined) {
                            queryParameters['allProducts'] = requestParameters.allProducts;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/search/filters",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.SearchRequestToJSON(requestParameters.searchRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.SearchFiltersResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get filters for a product search with filters applied (eg fetching HWC products require some filters to always be applied to ensure only hot water cylinders are returned)
     */
    ContentApi.prototype.getSearchFiltersWithFiltersApplied = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSearchFiltersWithFiltersAppliedRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get service items, used for orders
     */
    ContentApi.prototype.getServiceItemsRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-API-Key"] = this.configuration.apiKey("X-API-Key"); // ApiKeyAuth authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/content/serviceItems",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.ServiceItemFromJSON); })];
                }
            });
        });
    };
    /**
     * Get service items, used for orders
     */
    ContentApi.prototype.getServiceItems = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getServiceItemsRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get standard hours for all regions and their branches
     */
    ContentApi.prototype.getStandardHoursRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.orderBranch !== undefined) {
                            queryParameters['orderBranch'] = requestParameters.orderBranch;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-API-Key"] = this.configuration.apiKey("X-API-Key"); // ApiKeyAuth authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/branches/standardHours",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.RegionStandardHoursFromJSON); })];
                }
            });
        });
    };
    /**
     * Get standard hours for all regions and their branches
     */
    ContentApi.prototype.getStandardHours = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getStandardHoursRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get top level categories without sub-categories
     */
    ContentApi.prototype.getTopLevelCategoryRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.customerId !== undefined) {
                            queryParameters['customerId'] = requestParameters.customerId;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/categories",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.CategoryResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get top level categories without sub-categories
     */
    ContentApi.prototype.getTopLevelCategory = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTopLevelCategoryRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Requests images for a given array of products. An email is sent to the admin with the product images requested.
     */
    ContentApi.prototype.requestImagesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling requestImages.');
                        }
                        queryParameters = {};
                        if (requestParameters.customerId !== undefined) {
                            queryParameters['customerId'] = requestParameters.customerId;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/requestImages",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.RequestImagesRequestToJSON(requestParameters.requestImagesRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Requests images for a given array of products. An email is sent to the admin with the product images requested.
     */
    ContentApi.prototype.requestImages = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.requestImagesRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Search backflow segment products by brand or type
     */
    ContentApi.prototype.searchBackflowProductsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.brand !== undefined) {
                            queryParameters['brand'] = requestParameters.brand;
                        }
                        if (requestParameters.type !== undefined) {
                            queryParameters['type'] = requestParameters.type;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/search/backflowProducts",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.BackflowProductsResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Search backflow segment products by brand or type
     */
    ContentApi.prototype.searchBackflowProducts = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.searchBackflowProductsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Search products by query
     */
    ContentApi.prototype.searchProductsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.query !== undefined) {
                            queryParameters['query'] = requestParameters.query;
                        }
                        if (requestParameters.categoryId !== undefined) {
                            queryParameters['categoryId'] = requestParameters.categoryId;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.pageSize !== undefined) {
                            queryParameters['pageSize'] = requestParameters.pageSize;
                        }
                        if (requestParameters.customerId !== undefined) {
                            queryParameters['customerId'] = requestParameters.customerId;
                        }
                        if (requestParameters.includePrices !== undefined) {
                            queryParameters['includePrices'] = requestParameters.includePrices;
                        }
                        if (requestParameters.branchId !== undefined) {
                            queryParameters['branchId'] = requestParameters.branchId;
                        }
                        if (requestParameters.productRange !== undefined) {
                            queryParameters['productRange'] = requestParameters.productRange;
                        }
                        if (requestParameters.countOnly !== undefined) {
                            queryParameters['countOnly'] = requestParameters.countOnly;
                        }
                        if (requestParameters.allProducts !== undefined) {
                            queryParameters['allProducts'] = requestParameters.allProducts;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/search/products",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.SearchRequestToJSON(requestParameters.searchRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.PagedProductsResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Search products by query
     */
    ContentApi.prototype.searchProducts = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.searchProductsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Search products by barcode
     */
    ContentApi.prototype.searchProductsByBarcodeRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.barcode === null || requestParameters.barcode === undefined) {
                            throw new runtime.RequiredError('barcode', 'Required parameter requestParameters.barcode was null or undefined when calling searchProductsByBarcode.');
                        }
                        queryParameters = {};
                        if (requestParameters.barcode !== undefined) {
                            queryParameters['barcode'] = requestParameters.barcode;
                        }
                        if (requestParameters.customerId !== undefined) {
                            queryParameters['customerId'] = requestParameters.customerId;
                        }
                        if (requestParameters.includePrices !== undefined) {
                            queryParameters['includePrices'] = requestParameters.includePrices;
                        }
                        if (requestParameters.branchId !== undefined) {
                            queryParameters['branchId'] = requestParameters.branchId;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/search/products/barcode",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ProductFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Search products by barcode
     */
    ContentApi.prototype.searchProductsByBarcode = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.searchProductsByBarcodeRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Set the carousel items for the platform (eg. to reorder all at once)
     */
    ContentApi.prototype.setCarouselItemsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.platform === null || requestParameters.platform === undefined) {
                            throw new runtime.RequiredError('platform', 'Required parameter requestParameters.platform was null or undefined when calling setCarouselItems.');
                        }
                        queryParameters = {};
                        if (requestParameters.platform !== undefined) {
                            queryParameters['platform'] = requestParameters.platform;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["admin"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin/content/carousel",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.CarouselRequestToJSON(requestParameters.carouselRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.CarouselResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Set the carousel items for the platform (eg. to reorder all at once)
     */
    ContentApi.prototype.setCarouselItems = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.setCarouselItemsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Set the home page items for the platform (eg. to reorder all at once)
     */
    ContentApi.prototype.setHomePageItemsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.platform === null || requestParameters.platform === undefined) {
                            throw new runtime.RequiredError('platform', 'Required parameter requestParameters.platform was null or undefined when calling setHomePageItems.');
                        }
                        queryParameters = {};
                        if (requestParameters.platform !== undefined) {
                            queryParameters['platform'] = requestParameters.platform;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["admin"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin/content/homePage",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.HomePageItemsRequestToJSON(requestParameters.homePageItemsRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.HomePageItemsResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Set the home page items for the platform (eg. to reorder all at once)
     */
    ContentApi.prototype.setHomePageItems = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.setHomePageItemsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update a carousel item
     */
    ContentApi.prototype.updateCarouselItemRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling updateCarouselItem.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["admin"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin/content/carousel/{id}".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.UpdateCarouselItemRequestToJSON(requestParameters.updateCarouselItemRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.CarouselResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update a carousel item
     */
    ContentApi.prototype.updateCarouselItem = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateCarouselItemRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update a home page tile item
     */
    ContentApi.prototype.updateHomePageItemRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling updateHomePageItem.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["admin"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/admin/content/homePage/{id}".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.UpdateHomePageItemRequestToJSON(requestParameters.updateHomePageItemRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.HomePageItemsResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update a home page tile item
     */
    ContentApi.prototype.updateHomePageItem = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateHomePageItemRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return ContentApi;
}(runtime.BaseAPI));
exports.ContentApi = ContentApi;
